/*/
 * 
 * --------------------------- Storage KEYS Utils ---------------------------
 * 
/*/
const USER_KEY = 'bookclub_user';
const CLUBS_KEY = 'bookclub_user_clubs';
const SUGGESTIONS_KEY = 'bookclub_suggestions';
const NOTES_KEY = 'bookclub_notesboard';
/*/
 * 
 * --------------------------- Storage CUtils ---------------------------
 * 
/*/
export function clearAllStorage() {
  sessionStorage.clear();
}
/*/
 * 
 * --------------------------- User Storage Utils ---------------------------
 * 
/*/
export function saveUserToStorage(userState) {
  sessionStorage.setItem(USER_KEY, JSON.stringify(userState));
}
export function loadUserFromStorage() {
  const data = sessionStorage.getItem(USER_KEY);
  return data ? JSON.parse(data) : null;
}
export function clearUserFromStorage() {
  sessionStorage.removeItem(USER_KEY);
}
export function removeUserRequest(clubId) {
  const userData = loadUserFromStorage();
  if (userData) {
    userData.userRequests = (userData.userRequests || []).filter(request => {
      const reqId = String(request?.clubId ?? request?.id ?? request);
      return reqId !== String(clubId);
    });
    saveUserToStorage(userData);
  }
}



/*/
 * 
 * --------------------------- Clubs Storage Utils ---------------------------
 * 
/*/
export function saveUserClubsToStorage(userClubs) {
  sessionStorage.setItem(CLUBS_KEY, JSON.stringify(userClubs));
}  
export function loadUserClubsFromStorage() {
  const data = sessionStorage.getItem(CLUBS_KEY);
  // Club slice is stored as an object (e.g., { activeClubId, clubs, allClubsReady })
  // Default to {} to match expected shape on initial load
  return data ? JSON.parse(data) : {};
}
export function clearUserClubsFromStorage() {
  sessionStorage.removeItem(CLUBS_KEY);
}
/*/
 * 
 * --------------------------- Suggestions Storage Utils ---------------------------
 * 
/*/
export function saveSuggestionsToStorage(suggestions) {
  sessionStorage.setItem(SUGGESTIONS_KEY, JSON.stringify(suggestions));
}
export function loadSuggestionsFromStorage() {
  const data = sessionStorage.getItem(SUGGESTIONS_KEY);
  return data ? JSON.parse(data) : {};
}
export function clearSuggestionsFromStorage() {
  sessionStorage.removeItem(SUGGESTIONS_KEY);
}
export function clearSuggestionsBooksFromStorage() {
  const data = loadSuggestionsFromStorage();
  const clearedData = {};
  for (const clubId in data) {
    clearedData[clubId] = {
      clubId: data[clubId].clubId,
      votingDeadline: data[clubId].votingDeadline,
      isVotingActive: data[clubId].isVotingActive,
      suggestedBooks: []
    };
  }
  saveSuggestionsToStorage(clearedData);
}
/*/
 * 
 * --------------------------- notes Storage Utils ---------------------------
 * 
/*/
export function saveNotesToStorage(notesboard) {
    // console.log("saving notesboard to storage:", notesboard)
  sessionStorage.setItem(NOTES_KEY, JSON.stringify(notesboard));
}
export function loadNotesFromStorage() {
  const data = sessionStorage.getItem(NOTES_KEY);
  return data ? JSON.parse(data) : {};
}
export function clearNotesFromStorage() {
  sessionStorage.removeItem(NOTES_KEY);
}
